// Institutions Krina is professionally associated with.
// Rendered as an auto-scrolling marquee on the About section.
// All logos are public artifacts uploaded by the user.

export const KRINA_INSTITUTES = [
  {
    id: "manchester-met",
    name: "Manchester Metropolitan University",
    shortName: "Manchester Met",
    logo: "/images/logo-manmet.webp",
    alt: "Manchester Metropolitan University logo",
    role: "BSc (Hons) Biomedical Science · BSc (Hons) Physiotherapy",
    href: "https://www.mmu.ac.uk",
  },
  {
    id: "liverpool",
    name: "University of Liverpool",
    shortName: "Liverpool",
    logo: "/images/logo-liverpool.webp",
    alt: "University of Liverpool logo",
    role: "Masters Module — Assessment & Management of TMD",
    href: "https://www.liverpool.ac.uk",
  },
  {
    id: "ucl",
    name: "University College London (UCL)",
    shortName: "UCL",
    logo: "/images/logo-ucl.svg",
    alt: "University College London logo",
    role: "Invited lecturer — MSc Audiology (2025)",
    href: "https://www.ucl.ac.uk",
  },
  {
    id: "ifm",
    name: "Institute for Functional Medicine",
    shortName: "IFM",
    logo: "/images/logo-ifm.svg",
    alt: "The Institute for Functional Medicine logo",
    role: "AFMCP Foundation Course (Cohort 108) — Washington DC",
    href: "https://www.ifm.org",
  },
  {
    id: "crafta",
    name: "CRAFTA® — Cranio Facial Therapy Academy",
    shortName: "CRAFTA®",
    logo: "/images/logo-crafta.webp",
    alt: "CRAFTA® Cranio Facial Therapy Academy logo",
    role: "Foundation Course, Parts 1 & 2 — Italy (2016)",
    href: "https://www.crafta.org",
  },
  {
    id: "watson-headache",
    name: "Watson Headache® Institute",
    shortName: "Watson Headache®",
    logo: "/images/logo-watson.webp",
    alt: "Watson Headache logo",
    role: "Foundation Course — 2017",
    href: "https://watsonheadache.com",
  },
  {
    id: "rocabado",
    name: "Instituto Rocabado",
    shortName: "Instituto Rocabado",
    logo: "/images/logo-rocabado.webp",
    alt: "Instituto Rocabado logo",
    role: "BOSCO TMD Course — 2017",
    // href intentionally omitted — original institutorocabado.com domain no longer resolves.
    // Card renders as non-clickable logo instead of a broken link.
  },
  {
    id: "columbia",
    name: "Columbia University",
    shortName: "Columbia",
    logo: "/images/logo-columbia.svg",
    alt: "Columbia University logo",
    role: "Orofacial Pain Clinic — Shadowing (2014)",
    href: "https://www.columbia.edu",
  },
  {
    id: "treating-tmj",
    name: "TreatingTMJ — Freedom Physical Therapy Services",
    shortName: "TreatingTMJ",
    logo: "/images/logo-treatingtmj.webp",
    alt: "TreatingTMJ.com — Freedom Physical Therapy Services logo",
    role: "TreatingTMJ Course by Michael Karegeannes (2025)",
    href: "https://www.treatingtmj.com",
  },
  {
    id: "ccma",
    name: "Cervico-Cranio-Mandibular Academy",
    shortName: "CCMA",
    logo: "/images/logo-ccmt.webp",
    alt: "CCMA — Cervico-Cranio-Mandibular Academy logo",
    role: "Advanced TMD Courses (2025)",
    href: "https://www.ccma-academy.com",
  },
];
